import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, TextareaAutosize, Box,
} from "@mui/material";

export default function CompanyChangeStatusDialog({ isOpen, action, handleConfirm, handleClose }) {
  const [remark, setRemark] = useState("");

  const onClose = () => {
    setRemark("");
    handleClose();
  };

  const onConfirm = () => {
    handleConfirm(action, remark);
    setRemark("");
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography style={{ fontWeight: 700, fontSize: 16, color: "#3A4D54" }}>
          Confirm to {action} this company?
        </Typography>
      </DialogTitle>
      <DialogContent>
        {action === "disable" && (
          <Box mt={1}>
            <Typography variant="body2" style={{ marginBottom: 8 }}>Remark:</Typography>
            <TextareaAutosize
              minRows={3}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #D0D5DD", fontSize: 14 }}
              placeholder="Enter remark..."
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions style={{ padding: 16 }}>
        <Button onClick={onClose} variant="outlined" style={{ color: "#3A4D54", borderColor: "#3A4D54" }}>No</Button>
        <Button onClick={onConfirm} variant="contained" style={{ backgroundColor: "#3A4D54", color: "#fff" }}>Yes</Button>
      </DialogActions>
    </Dialog>
  );
}
